<template>
  <qx-card title="接单记录">
    <qx-img-dialog ref="imgDialog" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'proof' && scope.row[scope.column.property]!==''" >
                <span v-for="(item,index) in JSON.parse(scope.row[scope.column.property])" :key="index">
                  <img :src="item.picFullUrl" style="width:100px;height:100px;cursor:pointer"
                       v-if="item.picFullUrl.substring(item.picFullUrl.lastIndexOf('.') + 1) !== 'pdf'"
                       @click="previewImg(item.picFullUrl)"/>
                   <a
                       class="cur"
                       v-if="item.picFullUrl.substring(item.picFullUrl.lastIndexOf('.') + 1) === 'pdf'"
                       :href="item.picFullUrl"
                       target="_blank"
                   >
                    <img style="width:100px;height:100px;cursor:pointer" src="~images/pdf-icon.png" />
                  </a>
                </span>
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import {getOrderMoneyTypeOperateRecordsByOrderId, getReceiptRecordList} from 'api/operate';
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
      searchBoxData: {
        sourceOfGoodsId: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'orderId', label: '订单号'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'dispatchOrderStatusName', label: '派单状态'},
          {prop: 'driverRate', label: '司机运价'},
          {prop: 'driverName', label: '司机姓名'},
          {prop: 'driverPhone', label: '司机手机号'},
          {prop: 'vehicleType', label: '车型'},
          {prop: 'orderReceivingTime', label: '接单时间'},
          {prop: 'opName', label: '操作人'},
          {prop: 'opDate', label: '操作时间'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getReceiptRecordList,
    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
  },
  // created() {
  //   this.searchBoxData.orderId=this.orderId||this.$route.query.id
  //   this.getData()
  // }
};
</script>

<style scoped>

</style>
